module.exports = __webpack_public_path__ + "img/placeholder-box.6fed5446.svg";